import { orchestrator } from 'satcheljs';
import { selectedDateUpdated } from 'owa-calendar-surface';
import { updateSelectedDate } from 'owa-agenda-events-list';
import { AgendaScenarioId } from '../constants';

orchestrator(selectedDateUpdated, actionMessage => {
    const { date } = actionMessage;
    updateSelectedDate(date, AgendaScenarioId);
});
